import * as THREE from 'three'
import { useTexture } from "@react-three/drei"
import { extend, useFrame } from '@react-three/fiber'
import { useRef } from 'react'
import useStore from '../AppStore'

class BgMaterial extends THREE.ShaderMaterial {
  constructor() {
    super({
      blending: THREE.NormalBlending,
      depthTest: true,
      side: THREE.DoubleSide,
      uniforms: {
        iTime: {
          value: 0
        },
        iResolution: {
         value: { x: 1024, y: 1024 }
        }
      },
      vertexShader: `
        varying vec2 vUv;
        float map(float value, float min1, float max1, float min2, float max2) {
          return min2 + (value - min1) * (max2 - min2) / (max1 - min1);
        }
        void main() {
          //vUv.x = map(position.z,-.5,.5,0.,1.);
          gl_Position = projectionMatrix * modelViewMatrix * vec4(position.xyz,1.0);
        }
      `,
      fragmentShader: `
        uniform float iTime;
        uniform vec2 iResolution;
        
        #define PI			3.14159265359
        #define RADIAN		180. / PI
        #define CAMERA_FOV	60.4 * RADIAN

        float hash(in vec3 p) {
            return fract(sin(dot(p,vec3(127.1,311.7, 321.4)))*43758.5453123);
        }

        float noise(in vec3 p) {
          
          p.z += iTime * .77;
          
          vec3 i = floor(p);
          vec3 f = fract(p); 
          f *= f * (3.-2.*f);

            vec2 c = vec2(0,1);

            return mix(
            mix(mix(hash(i + c.xxx), hash(i + c.yxx),f.x),
              mix(hash(i + c.xyx), hash(i + c.yyx),f.x),
              f.y),
            mix(mix(hash(i + c.xxy), hash(i + c.yxy),f.x),
              mix(hash(i + c.xyy), hash(i + c.yyy),f.x),
              f.y),
            f.z);
        }

        float fbm(in vec3 p)
        {
          float f = 0.;
          f += .50000 * noise(1. * p);
          f += .25000 * noise(2. * p);
          f += .12500 * noise(4. * p);
          f += .06250 * noise(8. * p);
          return f;
        }

        struct Camera	{ vec3 p, t, u; };
        struct Ray		{ vec3 o, d; };

        void generate_ray(Camera c, out Ray r, in vec2 fragCoord)
        {
          float ratio = iResolution.x / iResolution.y;
          vec2  uv = (2.0 * fragCoord.xy / iResolution.xy - 1.) * vec2(ratio, 1.0);
          
          r.o = c.p;
          r.d = normalize(vec3(uv.x, uv.y, 1.0 / tan(CAMERA_FOV * .5)));
          
          vec3 cd = c.t - c.p;

          vec3 rx,ry,rz;
          rz = normalize(cd);
          rx = normalize(cross(rz, c.u));
          ry = normalize(cross(rx, rz));
          
          mat3 tmat = mat3(
                  rx.x, rx.y, rx.z,
                  ry.x, ry.y, ry.z,
                  rz.x, rz.y, rz.z
                );

          r.d = normalize(tmat * r.d);
        }

        vec3 cubemap(vec3 d, vec3 c1, vec3 c2)
        {
          return fbm(d) * mix(c1, c2, d * .5 + .5);
        }

        void main() {
          Camera c;
          Ray r;

          float rx = 300. * sin(mod(iTime * .64, 2. * PI)) - 500.;

          c.p = vec3(0., 0., 75.);
          c.u = vec3(0., 1., 0.);
          c.t = vec3(rx, 1500., 0.);
          //c.t = vec3(
          //      150. * sin(mod(iTime * .64, 2. * PI)),
          //      150. * cos(mod(iTime * .43, 2. * PI)),
          //      -150. * cos(mod(iTime * .20, 2. * PI)));
            
            generate_ray(c, r, gl_FragCoord.xy);
            vec3 col = cubemap(r.d,vec3(.0,.0,.06), vec3(.08,.0,.0));
            gl_FragColor = vec4(col*1.3, 1);
        }
        `
    })
  }
}

extend({BgMaterial})

export default function BackgroundShaderPlane(props) {
  const meshRef = useRef(null)
  useFrame(({clock}) => {
    const top = useStore.getState().top
    meshRef.current.material.uniforms.iTime.value = clock.elapsedTime * 0.15 + top*0.0005
    meshRef.current.material.uniforms.iResolution.value.x = window.innerWidth
    meshRef.current.material.uniforms.iResolution.value.y = window.innerHeight
    // meshRef.current.scale.x = window.innerWidth*20
    // console.log(clock.elapsedTime)
  })
  return (
    <mesh {...props} ref={meshRef} scale={[100000,100000,100000]} renderOrder={-1}>
      <planeBufferGeometry attach="geometry" args={[1, 1]} />
      <bgMaterial />
    </mesh>
  )
}